document.addEventListener("DOMContentLoaded", function () {
  const colorVariants = document.querySelectorAll('input[name="Color"]');
  const priceElement = document.querySelector(".product__price");
  const addToCartButton = document.querySelector('button[type="submit"]');

  // Ensure the first color variant is selected and recognized on page load
  if (colorVariants.length > 0) {
    const firstColorVariant = colorVariants[0];
    if (!firstColorVariant.checked) {
      firstColorVariant.checked = true; // Force the first color to be checked
    }
    triggerVariantChange(firstColorVariant); // Manually trigger the change event for the first color
    updatePrice(firstColorVariant); // Update price based on the first color variant
    updateVariantUrl(firstColorVariant); // Update URL based on the first color variant
    setAddToCartState(true); // Enable the "Add to Cart" button
  }

  // Listen for changes in the color selection
  colorVariants.forEach((swatch) => {
    swatch.addEventListener("change", function () {
      updatePrice(swatch); // Update price when color is changed
      updateVariantUrl(swatch); // Update URL when color is changed
      setAddToCartState(true); // Enable "Add to Cart" button
    });
  });

  // Function to update the variant URL
  function updateVariantUrl(swatch) {
    const variantId = findVariantId(swatch.value);
    if (variantId) {
      const newUrl = `${window.location.pathname}?variant=${variantId}`;
      window.history.replaceState(null, "", newUrl); // Update the URL without reloading
    }
  }

  // Function to update the price
  function updatePrice(swatch) {
    const variant = findVariantByValue(swatch.value);
    if (variant && priceElement) {
      priceElement.innerHTML = Shopify.formatMoney(variant.price); // Update price
    }
  }

  // Helper function to find the variant by its value
  function findVariantByValue(value) {
    return product?.variants?.find((v) => v.option1 === value); // Adjust for your variant options
  }

  // Helper function to find variant ID by value
  function findVariantId(value) {
    const variant = findVariantByValue(value);
    return variant ? variant.id : null;
  }

  // Function to enable or disable the "Add to Cart" button
  function setAddToCartState(isEnabled) {
    if (addToCartButton) {
      if (isEnabled) {
        addToCartButton.disabled = false; // Enable the button
        addToCartButton.classList.remove("disabled");
      } else {
        addToCartButton.disabled = true; // Disable the button
        addToCartButton.classList.add("disabled");
      }
    }
  }

  // Function to manually trigger the variant change event
  function triggerVariantChange(swatch) {
    const event = new Event("change", { bubbles: true, cancelable: true });
    swatch.dispatchEvent(event);
  }

  // Disable the "Add to Cart" button initially until a valid variant is selected
  setAddToCartState(true);
});
